import { requiredConfig } from './config';

// Managed login config (Cognito hosted OAuth code flow). No identity pool: no
// code in this app uses AWS credentials, only the bearer token.
const origin =
  typeof window !== 'undefined'
    ? window.location.origin
    : 'http://localhost:3000';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: requiredConfig(
        'REACT_APP_COGNITO_USER_POOL_ID',
        process.env.REACT_APP_COGNITO_USER_POOL_ID,
      ),
      userPoolClientId: requiredConfig(
        'REACT_APP_COGNITO_CLIENT_ID',
        process.env.REACT_APP_COGNITO_CLIENT_ID,
      ),
      loginWith: {
        oauth: {
          domain: requiredConfig(
            'REACT_APP_COGNITO_SIGN_IN_DOMAIN',
            process.env.REACT_APP_COGNITO_SIGN_IN_DOMAIN,
          ),
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [`${origin}/auth/callback`],
          redirectSignOut: [`${origin}/`],
          responseType: 'code',
        },
      },
    },
  },
};
export default awsConfig;
